// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"a5b6b898","432":"4dadab32","453":"d855a71b","533":"b287af73","658":"8047c429","812":"7f3fc57a","813":"d59ced99","895":"c70787ae"}[chunkId] + ".chunk.js";
};